export const vcardService = {
  getVCardString: (card) => {
    const vis = card.contact_visibility || { email: true, phone: true, website: true, location: true };
    
    // Properly escape special characters for vCard 3.0
    const escape = (str) => {
      if (!str) return '';
      return str.replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,').replace(/\n/g, '\\n');
    };

    let vcard = `BEGIN:VCARD\nVERSION:3.0\n`;
    vcard += `FN:${escape(card.full_name)}\n`;

    const nameParts = (card.full_name || '').split(' ');
    const first = nameParts[0] || '';
    const last = nameParts.length > 1 ? nameParts.slice(1).join(' ') : '';
    vcard += `N:${escape(last)};${escape(first)};;;\n`;

    if (card.job_title) vcard += `TITLE:${escape(card.job_title)}\n`;
    if (card.company_name) vcard += `ORG:${escape(card.company_name)}\n`;

    if (vis.email && card.email) vcard += `EMAIL;TYPE=WORK,INTERNET:${escape(card.email)}\n`;
    if (vis.phone && card.phone) vcard += `TEL;TYPE=WORK,VOICE:${escape(card.phone)}\n`;
    if (vis.website && card.website) vcard += `URL:${escape(card.website)}\n`;

    let note = '';
    if (card.bio) note += card.bio + '\n\n';
    note += `Digital Card: ${window.location.origin}${window.location.pathname}#/c/${card.public_slug}`;
    vcard += `NOTE:${escape(note)}\n`;

    vcard += `END:VCARD\n`;
    return vcard;
  },

  getVCardBlob: (card) => {
    const vcardString = vcardService.getVCardString(card);
    return new Blob([vcardString], { type: 'text/vcard;charset=utf-8' });
  },

  generateAndDownload: (card) => {
    const blob = vcardService.getVCardBlob(card);
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    
    link.href = url;
    link.download = `${card.public_slug || 'meetoi-contact'}.vcf`;
    document.body.appendChild(link);
    link.click();
    
    // Clean up
    setTimeout(() => {
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }, 100);
  }
};